// extracted by mini-css-extract-plugin
export default {"statisticsGroup":"StatisticsGroup-module__statisticsGroup--YyWBO","statisticWrapper":"StatisticsGroup-module__statisticWrapper--apENp","body":"StatisticsGroup-module__body--nmu0j"};